import { render, staticRenderFns } from "./GetAddress.vue?vue&type=template&id=f2ee9d8c&"
import script from "./GetAddress.vue?vue&type=script&lang=js&"
export * from "./GetAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports